import { MealTypesFormFields, AddUpdateMealTypeDTO } from 'types';

export const parseMealTypesFormFieldsIntoAddUpdateMealTypeDTO = (
    mealTypeData: MealTypesFormFields,
): AddUpdateMealTypeDTO => ({
    name: mealTypeData.name,
});
